import { render, staticRenderFns } from "./SameMusic.vue?vue&type=template&id=c06928e2&scoped=true"
import script from "./SameMusic.vue?vue&type=script&lang=js"
export * from "./SameMusic.vue?vue&type=script&lang=js"
import style0 from "./SameMusic.vue?vue&type=style&index=0&id=c06928e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06928e2",
  null
  
)

export default component.exports